export const exportHeaders = [
    {
        label: "Transaction ID",
        key: "transaction_id"
    },

    {
        label: "Order Date",
        key: "order_date"
    },


    {
        label: "Billto ID",
        key: "customer_billto_account_number"
    },

    {
        label: "Loyalty Id",
        key: "loyalty_id"
    },

    {
        label: "Type",
        key: "type"
    },

    {
        label: "Transaction Type",
        key: "transaction_type"
    },

    {
        label: "Transaction Status",
        key: "transaction_status"
    },
   


]